import { memo, type MouseEvent as ReactMouseEvent } from 'react';
import { Center, Column, Row, Typography } from '@tempmee/react';
import { Value as FieldValue } from '~/commonComponents/InputJob/Field';
import { colors } from '@tempmee/tailwind';
import { OutlinePlusIcon, OutlineXIcon } from '@tempmee/react-icons';
import { IInputInviteCandidateValue } from './Types';

interface IValueProps {
  values?: IInputInviteCandidateValue[];
  onInviteMoreClick?(): void;
  onRemoveProfessional?(value: IInputInviteCandidateValue, index: number): void;
}

const Component = ({ values = [], onInviteMoreClick, onRemoveProfessional }: IValueProps) => {
  const hasValues = values.length > 0;

  const handleInviteMoreClick = (e: ReactMouseEvent) => {
    e.stopPropagation();
    onInviteMoreClick?.();
  };

  const handleRemoveProfessionalClick = (index: number) => (e: ReactMouseEvent) => {
    e.stopPropagation();
    onRemoveProfessional?.(values[index], index);
  };

  if (!hasValues) {
    return <FieldValue style={{ color: colors.neutral[300] }} text="Add Candidates" />;
  }

  return (
    <Column align="end" gap={4}>
      {values.map((it, i) => (
        <Row data-testid={`input-invite-candidate.item-${it.value}`} key={it.value}>
          <Typography
            as="span"
            data-testid={`input-invite-candidate.item-${it.value}.text`}
            style={{ textTransform: 'capitalize' }}
          >
            {it.label}
          </Typography>
          <Center
            data-testid={`input-invite-candidate.item-${it.value}.close-icon`}
            className="cursor-pointer"
            role="button"
            onClick={handleRemoveProfessionalClick(i)}
            // FIXME(layout-migration): band-aid offset margins preserved verbatim;
            // not portable to gap (overflow positioning) — verify visually before removing
            style={{ marginLeft: 30, marginRight: -30 }}
          >
            <OutlineXIcon color={colors.secondary[500]} />
          </Center>
        </Row>
      ))}

      <Row
        align="center"
        className="cursor-pointer"
        data-testid={`input-invite-candidate.add-invite-more`}
        gap={2}
        role="button"
        onClick={handleInviteMoreClick}
      >
        <OutlinePlusIcon color={colors.secondary[500]} />
        <Typography as="span" bold color={colors.secondary[500]} size="body_large">
          Invite More
        </Typography>
      </Row>
    </Column>
  );
};

export const Value = memo(Component);
